import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useRef, useState, useEffect } from 'react';
import { Row, Col, Table, Dropdown, useIsMounted, useUser, useWindowSize } from 'components';
import { showApiError } from 'utils';
import { getOverdueCredits, getAllFranchises } from 'services';
import { tableWrap } from 'styles';
import { creditListColumns, creditCardRenderer } from 'screens/Private/Credits/config';
import { tableHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var CARD_BREAKPOINT = 1200;

var OverdueCreditsTab = function OverdueCreditsTab() {
  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData,
      userInfo = _useUser.userInfo;

  var _useWindowSize = useWindowSize(),
      windowWidth = _useWindowSize.width;

  var tableRef = useRef();
  var isMounted = useIsMounted();
  var queryParams = useRef({});
  var isMobile = windowWidth < CARD_BREAKPOINT;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      franchisees = _useState2[0],
      setFranchisees = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedFranchisee = _useState4[0],
      setSelectedFranchisee = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedOffice = _useState6[0],
      setSelectedOffice = _useState6[1];

  var offices = (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.offices) || [];
  useEffect(function () {
    if (roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenant) fetchFranchisees();
  }, [roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant]);
  useEffect(function () {
    if (isMounted.current) {
      var _tableRef$current;

      queryParams.current = {
        franchisee: selectedFranchisee,
        office: selectedOffice
      };
      (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.getData(queryParams.current);
    }
  }, [selectedFranchisee, selectedOffice]);

  var fetchFranchisees = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAllFranchis, _yield$getAllFranchis2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllFranchises();

            case 2:
              _yield$getAllFranchis = _context.sent;
              _yield$getAllFranchis2 = _slicedToArray(_yield$getAllFranchis, 2);
              res = _yield$getAllFranchis2[0];
              err = _yield$getAllFranchis2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setFranchisees(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchFranchisees() {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchOverdueCredits = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tableOptions) {
      var _yield$getOverdueCred, _yield$getOverdueCred2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getOverdueCredits(tableOptions);

            case 2:
              _yield$getOverdueCred = _context2.sent;
              _yield$getOverdueCred2 = _slicedToArray(_yield$getOverdueCred, 2);
              res = _yield$getOverdueCred2[0];
              err = _yield$getOverdueCred2[1];

              if (!err) {
                _context2.next = 9;
                break;
              }

              showApiError(err);
              return _context2.abrupt("return", [null, err]);

            case 9:
              return _context2.abrupt("return", [res, null]);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchOverdueCredits(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var filterBar = function filterBar() {
    return ___EmotionJSX("section", {
      css: tableHeaderContainer
    }, ___EmotionJSX(Row, {
      horizontalGap: 16,
      verticalGap: 8
    }, (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant) && ___EmotionJSX(Col, {
      sm: 12,
      md: 3
    }, ___EmotionJSX(Dropdown, {
      small: true,
      withSearch: true,
      placeholder: "\u041A\u0440\u0435\u0434\u0438\u0442\u0435\u043D \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A",
      displayKey: "name",
      uniqueKey: "id",
      value: selectedFranchisee,
      options: franchisees,
      onChange: setSelectedFranchisee,
      mapValue: function mapValue(val) {
        return val === null || val === void 0 ? void 0 : val.id;
      }
    })), offices.length > 0 && ___EmotionJSX(Col, {
      sm: 12,
      md: 3
    }, ___EmotionJSX(Dropdown, {
      small: true,
      withSearch: true,
      placeholder: "\u041E\u0444\u0438\u0441",
      displayKey: "name",
      uniqueKey: "id",
      value: selectedOffice,
      options: offices,
      onChange: setSelectedOffice,
      mapValue: function mapValue(val) {
        return val === null || val === void 0 ? void 0 : val.id;
      }
    }))));
  };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX(Table, {
    hasPagination: true,
    ref: tableRef,
    getDataMethod: fetchOverdueCredits,
    columns: isMobile ? [] : creditListColumns(roleAdditionalData, userInfo),
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0438 \u0438\u043B\u0438 \u043F\u0430\u0434\u0435\u0436\u0438\u0440\u0430\u043B\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0438",
    filterBar: filterBar,
    margin: "0 2em",
    pageSize: 20,
    renderRow: isMobile ? creditCardRenderer(roleAdditionalData, userInfo) : undefined
  })));
};

export default OverdueCreditsTab;